import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/messaging';
import Messaging from './Messaging';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.messaging,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(Messaging);
